module.exports = __webpack_public_path__ + "media/images/icon-user-f068b7de4128e774919cc2f4dc024541.svg";